module.exports = {
  label: 'ข้อมูลสินค้าพิเศษ',
  CLASSNO: 'ประเภทสินค้าอันตราย (CLASS NO)',
  UNNO: 'เลขหมายสหประชาชาติ',
  PACKING: 'ประเภทบรรจุภัณฑ์สินค้า',
  EMS: 'ตารางฉุกเฉิน',
  Point: 'จุดวาบไฟ',
  Isolation: 'แยก',
  man24: 'ผู้ติดต่อฉุกเฉิน 24 ชั่วโมง',
  tel24: 'หมายเลขโทรศัพท์',
  ResponsibleParty: 'ฝ่ายรับผิดชอบ',
  HSCODE: 'รหัส HS',
  ContractNbr: 'เลขที่สัญญา',
  SHIPPER: 'ขนาด (ยาว x กว้าง x สูง)',
  PickTime: 'เวลารับตู้คอนเทนเนอร์',
  SeaPullution: 'มลพิษทางทะเล',
  GOH: 'ตู้แขวนเสื้อผ้า',
  Tier: 'ชั้น',
  Hanger: 'จำนวนต่อชั้น',
  Ropes: 'จำนวนเชือกต่อท่อ',
  Knots: 'จำนวนปมต่อเชือก',
  ReformCost: 'ค่าใช้จ่ายในการปรับเปลี่ยน',
  Warehouse: 'คลังสินค้าเข้า',
  Reefer: 'ตู้แช่เย็น',
  humidity: 'ความชื้น (%)',
  ventilation: 'ปริมาณการระบายอากาศ (m3)',
  Business: 'ต้องตรวจสอบสินค้าหรือไม่',
  PTI: 'จำนวนวันล่วงหน้าในการทำความเย็น',
  ContainerYard: 'จุดรับตู้คอนเทนเนอร์',
  Address: 'ข้อมูลจุดรับส่ง',
  StuffingTime: 'เวลาบรรจุตู้',
  DeliverTime: 'ท่าเรือส่งตู้คอนเทนเนอร์',
  WarehousingTime: 'วันที่เข้าโกดัง',
  DoccutoffTime: 'วันปิดรับเอกสาร',
  CustomsCutoffTime: 'วันปิดประตู',
  CorrectTransportName: 'ชื่อการขนส่งที่ถูกต้อง',
  SecondarySpecialGoods: 'ประเภทอันตรายรอง',
  GrossWeight: 'น้ำหนักรวม',
  NeatWeight: 'น้ำหนักสุทธิ',
  OuterPackagingType: 'ประเภทบรรจุภัณฑ์ภายนอก',
  OuterPackagingQuantity: 'จำนวนบรรจุภัณฑ์ภายนอก',
  InnerPackagingType: 'ประเภทบรรจุภัณฑ์ภายใน',
  InnerPackagingQuantity: 'จำนวนบรรจุภัณฑ์ภายใน',
  Remark: 'หมายเหตุ',
  Add: 'เพิ่ม',
  Delete: 'ลบ',
  PackingCode: 'รหัสบรรจุภัณฑ์',
  Import: 'นำเข้า',
  FillIn: 'เชื่อมโยง',
  OnlyEnterYN: 'สามารถป้อนได้เฉพาะ Y หรือ N',
  ThisFieldRequired: 'หากประเภทบรรจุภัณฑ์ภายนอกเป็น 4G ต้องกรอกข้อมูลในช่องนี้',
  HumidityToolTip: 'ความชื้น = เปอร์เซ็นต์ความชื้นในอากาศ',
  Temp: 'อุณหภูมิ',
  VentilationWse: 'ปริมาณการระบายอากาศ',
  VgmWeight: 'น้ำหนัก VGM',
  dgContactEmail: 'อีเมลติดต่อผู้รับผิดชอบวัตถุอันตราย',
  dgContactFax: 'แฟกซ์ติดต่อผู้รับผิดชอบวัตถุอันตราย',
  bookingNo: 'หมายเลขการจองตู้ขนส่ง',
  TemperatureUnit: 'หน่วยอุณหภูมิ'
}
